import React from "react";
import PropTypes from "prop-types";

export const getMedallionColor = (lbl) => {
  if (typeof lbl !== "string") return [];
  const lower = lbl.toLowerCase();
  if (lower.includes("coed") || lower.includes("co-ed")) {
    return ["split"];
  }
  const colorMap = {
    turquoise: "var(--color-turquoise)",
    ruby: "var(--color-ruby)",
    leather: "var(--color-leather)",
    red: "#ff4d4d",
    blue: "#2196f3",
    green: "#4caf50",
    yellow: "#ffeb3b",
    orange: "#ff9800",
    purple: "#9c27b0",
    pink: "#e91e63",
    bronze: "var(--color-bronze)",
    silver: "var(--color-silver)",
    gold: "var(--color-gold)",
    copper: "var(--color-copper)",
    platinum: "var(--color-platinum)",
    girls: "var(--color-ruby)",
    girl: "var(--color-ruby)",
    "women's": "var(--color-ruby)",
    "women’s": "var(--color-ruby)",
    womens: "var(--color-ruby)",
    women: "var(--color-ruby)",
    female: "var(--color-ruby)",
    boys: "var(--color-turquoise)",
    boy: "var(--color-turquoise)",
    "men's": "var(--color-turquoise)",
    "men’s": "var(--color-turquoise)",
    mens: "var(--color-turquoise)",
    men: "var(--color-turquoise)",
    male: "var(--color-turquoise)",
  };
  const matches = [];
  for (const [key, value] of Object.entries(colorMap)) {
    // Use regex word boundaries to avoid matching "men" inside "women"
    const regex = new RegExp(String.raw`\b${key}\b`, "i");
    if (regex.test(lower)) {
      matches.push(value);
    }
  }
  return matches;
};

export const ChipMedallion = ({ label }) => {
  const medallionColors = getMedallionColor(label);

  if (medallionColors.length === 0) return null;

  if (medallionColors[0] === "split") {
    return (
      <span
        data-testid="chip-medallion-split"
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          border: "1px solid rgba(0,0,0,0.15)",
          flexShrink: 0,
          display: "inline-flex",
          overflow: "hidden",
        }}
      >
        <span
          style={{
            width: "50%",
            height: "100%",
            backgroundColor: "var(--color-turquoise)",
          }}
        />
        <span
          style={{
            width: "50%",
            height: "100%",
            backgroundColor: "var(--color-ruby)",
          }}
        />
      </span>
    );
  }

  // Handle single or multiple distinct matched colors
  const uniqueColors = Array.from(new Set(medallionColors));
  return (
    <span
      data-testid="chip-medallion"
      style={{ display: "inline-flex", gap: "2px", flexShrink: 0 }}
    >
      {uniqueColors.map((color, idx) => (
        <span
          key={`${color}-${idx}`}
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: color,
            border: "1px solid rgba(0,0,0,0.15)",
          }}
        />
      ))}
    </span>
  );
};

ChipMedallion.propTypes = {
  label: PropTypes.string,
};
